import type { Rect } from '~/types/pipeline';
import type { CvApi } from '~/workers/cv.worker';
import { makeWorkerSingleton } from './comlink-worker';

export const cv = makeWorkerSingleton<CvApi>(
  () => new Worker(new URL('../workers/cv.worker.ts', import.meta.url), { type: 'module' }),
);

if (import.meta.hot) import.meta.hot.dispose(cv.dispose);

export function maskFromRegion(imageData: ImageData, region: Rect): ImageData {
  const mask = new ImageData(imageData.width, imageData.height);
  const x0 = Math.max(0, Math.round(region.x));
  const y0 = Math.max(0, Math.round(region.y));
  const x1 = Math.min(imageData.width, Math.round(region.x + region.w));
  const y1 = Math.min(imageData.height, Math.round(region.y + region.h));
  for (let y = y0; y < y1; y++) {
    for (let x = x0; x < x1; x++) {
      const i = (y * imageData.width + x) * 4;
      mask.data[i] = 255;
      mask.data[i + 1] = 255;
      mask.data[i + 2] = 255;
      mask.data[i + 3] = 255;
    }
  }
  return mask;
}

export function inpaintTeleaViaWorker(
  imageData: ImageData,
  region: Rect,
  radius = 3,
): Promise<ImageData> {
  const mask = maskFromRegion(imageData, region);
  return cv.get().inpaintTelea(imageData, mask, radius);
}
